import { Clock, Users } from 'lucide-react'
import { cn, formatTime } from '@/lib/utils'
import type { DayPlan } from './meal-planning-utils'
import { formatDutchDate } from './meal-planning-utils'

interface WeekDayCardProps {
  day: DayPlan
  selected: boolean
  onSelect: (dateKey: string) => void
}

export function WeekDayCard({ day, selected, onSelect }: WeekDayCardProps) {
  const primaryMeal = day.meals[0]

  return (
    <button
      type="button"
      onClick={() => onSelect(day.dateKey)}
      className={cn(
        'min-h-[196px] w-[220px] shrink-0 rounded-xl border p-4 text-left transition-colors sm:w-[240px]',
        selected ? 'border-orange-400 bg-orange-50 shadow-sm' : 'border-gray-200 bg-white hover:border-gray-300'
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-semibold text-gray-900">{day.label}</div>
          <div className="text-sm text-gray-500">{formatDutchDate(day.date, { day: 'numeric', month: 'long' })}</div>
        </div>
        {day.isToday ? (
          <span className="rounded-full bg-orange-100 px-2 py-1 text-xs font-medium text-orange-800">Vandaag</span>
        ) : null}
      </div>

      <div className="mt-4 rounded-lg border border-dashed border-gray-200 bg-gray-50 p-3">
        {primaryMeal ? (
          <div className="flex min-h-[92px] flex-col justify-between gap-3">
            <div className="space-y-2">
              <div className="text-xs font-medium uppercase tracking-wide text-orange-700">Gepland diner</div>
              <div className="line-clamp-3 break-words text-sm font-medium leading-5 text-gray-900">
                {primaryMeal.recipe?.title ?? 'Onbekend recept'}
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-3 text-xs text-gray-500">
              {primaryMeal.recipe && (primaryMeal.recipe.prep_time || primaryMeal.recipe.cook_time) ? (
                <span className="flex items-center gap-1">
                  <Clock className="h-3.5 w-3.5" />
                  {formatTime((primaryMeal.recipe.prep_time || 0) + (primaryMeal.recipe.cook_time || 0))}
                </span>
              ) : null}
              {primaryMeal.planned_servings ? (
                <span className="flex items-center gap-1">
                  <Users className="h-3.5 w-3.5" />
                  {primaryMeal.planned_servings}
                </span>
              ) : null}
            </div>
            {day.meals.length > 1 ? (
              <div className="text-xs font-medium text-orange-700">+{day.meals.length - 1} extra gepland</div>
            ) : null}
          </div>
        ) : (
          <div className="flex min-h-[92px] items-center justify-center text-center text-sm text-gray-500">
            Nog niets gepland
          </div>
        )}
      </div>
    </button>
  )
}
